export const CLOSE_PHYSICAL_WARNING =
  'Are you sure you wish to close this Physical?';
export const FUTURE_PHYSICAL_DATE_MESSAGE =
  'Future Physical date entered, are you sure Y/N?';
export const DO_YOU_WANT_TO_CONTINUE_MESSAGE = 'Do you want to continue?';



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/helper/Constants.js